import { useMutation } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api';

import { DigiQuoteSettings, QuoteSenderSettings } from './types';

export type UseUpdateQuoteSenderSettingsParams = {
  groupId: string;
};

export const getUpdateQuoteSenderSettingsKey = (
  params: UseUpdateQuoteSenderSettingsParams,
) => ['suppliers', params.groupId, 'updateQuoteSenderSettings'] as const;

export const useUpdateQuoteSenderSettings: MutationFunction<
  DigiQuoteSettings,
  QuoteSenderSettings,
  [UseUpdateQuoteSenderSettingsParams]
> = (params, { requestOptions, queryOptions } = {}) => {
  const { groupId } = params;

  const mutationKey = getUpdateQuoteSenderSettingsKey(params);
  const request = useRequest(requestOptions);

  return useMutation(
    (body) => {
      return request(`/suppliers/${groupId}/digi_quote_settings`, {
        init: {
          method: 'PATCH',
          body,
        },
      });
    },
    {
      ...queryOptions,
      mutationKey,
    },
  );
};
